/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryTree} from '../models/DictionaryTree';
import type {Error} from '../models/Error';

export interface GetSupportedSsoAuditActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedSsoAuditActionsRequest = createAction<PayloadData<void>>('DICTIONARY__GET_SUPPORTED_SSO_AUDIT_ACTIONS__REQUEST');
export const getSupportedSsoAuditActionsSuccess = createAction<PayloadData<Array<DictionaryTree>>>('DICTIONARY__GET_SUPPORTED_SSO_AUDIT_ACTIONS__SUCCESS');
export const getSupportedSsoAuditActionsFailure = createAction<PayloadData<Error, void, true>>('DICTIONARY__GET_SUPPORTED_SSO_AUDIT_ACTIONS__FAILURE');

export const getSupportedSsoAuditActionsActions = [
    getSupportedSsoAuditActionsRequest,
    getSupportedSsoAuditActionsSuccess,
    getSupportedSsoAuditActionsFailure
] as const;

/**
 * Get supported audit action categories and actions for an SSO
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedSsoAuditActions = (config?: GetSupportedSsoAuditActions$Config) => {
    return {
        CALL_API: {
            types: getSupportedSsoAuditActionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/sso-audit-actions`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSupportedUserAuditActions$Request {
    userId: number;
}

export interface GetSupportedUserAuditActions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSupportedUserAuditActionsRequest = createAction<PayloadData<void, GetSupportedUserAuditActions$Request>>('DICTIONARY__GET_SUPPORTED_USER_AUDIT_ACTIONS__REQUEST');
export const getSupportedUserAuditActionsSuccess = createAction<PayloadData<Array<DictionaryTree>, GetSupportedUserAuditActions$Request>>('DICTIONARY__GET_SUPPORTED_USER_AUDIT_ACTIONS__SUCCESS');
export const getSupportedUserAuditActionsFailure = createAction<PayloadData<Error, GetSupportedUserAuditActions$Request, true>>('DICTIONARY__GET_SUPPORTED_USER_AUDIT_ACTIONS__FAILURE');

export const getSupportedUserAuditActionsActions = [
    getSupportedUserAuditActionsRequest,
    getSupportedUserAuditActionsSuccess,
    getSupportedUserAuditActionsFailure
] as const;

/**
 * Get supported audit action categories and actions for a portal user
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSupportedUserAuditActions = (meta: GetSupportedUserAuditActions$Request, config?: GetSupportedUserAuditActions$Config) => {
    const TRANSPORT_GET_PARAMS = {
        userId: meta.userId,
    };
    return {
        CALL_API: {
            types: getSupportedUserAuditActionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/user-audit-actions`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

